/* Luna Stories 2.0 | Vanilla JS; lazy player; Shopify Online Store 2.0 */
(() => {
  'use strict';
  if (window.__LUNA_STORIES_2_BOOTSTRAPPED__) return;
  window.__LUNA_STORIES_2_BOOTSTRAPPED__ = true;

  const one = (root, selector) => root.querySelector(selector);
  const all = (root, selector) => Array.from(root.querySelectorAll(selector));
  const routeRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  class LunaStories {
    constructor(root) {
      this.root = root;
      this.items = all(root, '[data-ls-item]').map(el => ({ ...el.dataset }));
      if (!this.items.length) return;
      this.dialog = one(root, '[data-ls-dialog]');
      this.videoWrap = one(root, '[data-ls-video-wrap]');
      this.progress = one(root, '[data-ls-progress]');
      this.label = one(root, '[data-ls-label]');
      this.replay = one(root, '[data-ls-replay]');
      this.message = one(root, '[data-ls-message]');
      this.mute = one(root, '[data-ls-mute]');
      this.product = one(root, '[data-ls-product]');
      this.add = one(root, '[data-ls-add]');
      this.cartLink = one(root, '[data-ls-cart-link]');
      this.index = 0;
      this.video = null;
      this.muted = true;
      this.startX = null;
      this.renderRail();
      this.bind();
    }

    renderRail() {
      const rail = one(this.root, '[data-ls-rail]');
      if (!rail) return;
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ls-rail-button';
        button.dataset.lsOpen = String(i);
        button.setAttribute('aria-label', 'Watch story ' + (i + 1) + ': ' + (item.label || 'Luna'));
        const ring = document.createElement('span');
        ring.className = 'ls-bubble-ring';
        if (item.poster) {
          const img = document.createElement('img');
          img.src = item.poster;
          img.alt = '';
          img.width = 74;
          img.height = 74;
          img.loading = 'lazy';
          img.decoding = 'async';
          ring.appendChild(img);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'ls-bubble-placeholder';
          placeholder.textContent = 'L';
          ring.appendChild(placeholder);
        }
        const caption = document.createElement('span');
        caption.className = 'ls-rail-label';
        caption.textContent = item.label || 'Luna Story';
        button.append(ring, caption);
        rail.appendChild(button);
      }
    }

    bind() {
      this.root.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-ls-open]');
        if (trigger && this.root.contains(trigger)) this.open(Number(trigger.dataset.lsOpen) || 0);
      });
      one(this.root, '[data-ls-close]').addEventListener('click', () => this.close());
      one(this.root, '[data-ls-prev]').addEventListener('click', () => this.navigate(-1));
      one(this.root, '[data-ls-next]').addEventListener('click', () => this.navigate(1));
      this.mute.addEventListener('click', () => {
        this.muted = !this.muted;
        if (this.video) this.video.muted = this.muted;
        this.renderMute();
      });
      this.replay.addEventListener('click', () => {
        if (!this.video) return;
        if (this.video.ended) this.video.currentTime = 0;
        this.play();
      });
      this.add.addEventListener('click', () => this.addToCart());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('close', () => this.cleanup());
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.navigate(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.navigate(-1); }
        if (event.code === 'Space' && event.target === this.dialog) { event.preventDefault(); this.togglePause(); }
      });
      const stage = one(this.root, '[data-ls-stage]');
      stage.addEventListener('touchstart', (event) => {
        if (event.touches.length === 1) this.startX = event.touches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', (event) => {
        if (this.startX === null || !event.changedTouches.length) return;
        const delta = event.changedTouches[0].clientX - this.startX;
        this.startX = null;
        if (Math.abs(delta) >= 60) this.navigate(delta < 0 ? 1 : -1);
      }, { passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && this.video) this.video.pause();
      });
    }

    open(index) {
      if (!this.dialog.open) {
        try { this.dialog.showModal(); }
        catch (error) { console.warn('Luna Stories: dialog unavailable', error); return; }
        document.body.classList.add('ls-locked');
      }
      this.show(index);
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    cleanup() {
      this.destroyVideo();
      if (!document.querySelector('.luna-stories .ls-dialog[open]')) document.body.classList.remove('ls-locked');
    }

    destroyVideo() {
      if (!this.video) return;
      this.video.pause();
      this.video.removeAttribute('src');
      all(this.video, 'source').forEach(source => source.removeAttribute('src'));
      this.video.load();
      this.video.remove();
      this.video = null;
      this.videoWrap.replaceChildren();
    }

    navigate(direction) {
      if (this.items.length < 2) {
        if (this.video) { this.video.currentTime = 0; this.play(); }
        return;
      }
      const next = (this.index + direction + this.items.length) % this.items.length;
      this.show(next);
    }

    show(index) {
      const next = Math.max(0, Math.min(index, this.items.length - 1));
      const item = this.items[next];
      if (!item) return;
      this.index = next;
      this.destroyVideo();
      this.replay.hidden = true;
      this.message.hidden = true;
      this.label.textContent = item.label || 'Luna Story';
      this.renderProgress();
      this.renderProduct(item);
      this.renderMute();

      // Media is created ONLY when the player is open. No preload on page load.
      const video = document.createElement('video');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.autoplay = true;
      video.muted = this.muted;
      video.preload = 'metadata';
      video.controls = false;
      video.setAttribute('aria-label', item.label || 'Luna Story');
      if (item.poster) video.poster = item.poster;
      const source = document.createElement('source');
      source.src = item.src;
      source.type = item.type || 'video/mp4';
      video.appendChild(source);
      video.addEventListener('timeupdate', () => {
        if (this.video !== video) return;
        if (video.duration && Number.isFinite(video.duration)) {
          this.updateProgress(Math.min(100, (video.currentTime / video.duration) * 100));
        }
      });
      video.addEventListener('ended', () => {
        if (this.video !== video) return;
        this.updateProgress(100);
        if (this.index < this.items.length - 1) this.show(this.index + 1);
        else { this.replay.textContent = '▶ Watch again'; this.replay.hidden = false; }
      });
      video.addEventListener('error', () => {
        if (this.video !== video) return;
        this.message.textContent = 'This video could not be loaded. Try the next story.';
        this.message.hidden = false;
      });
      video.addEventListener('click', () => this.togglePause());
      this.video = video;
      this.videoWrap.appendChild(video);
      this.play();
    }

    play() {
      if (!this.video) return;
      const playingVideo = this.video;
      const promise = playingVideo.play();
      if (promise && typeof promise.then === 'function') {
        promise.then(() => { if (this.video === playingVideo) this.replay.hidden = true; }).catch(() => {
          if (this.video !== playingVideo) return;
          this.replay.textContent = '▶ Play video';
          this.replay.hidden = false;
        });
      }
    }

    togglePause() {
      if (!this.video) return;
      if (this.video.paused) this.play();
      else {
        this.video.pause();
        this.replay.textContent = '▶ Play video';
        this.replay.hidden = false;
      }
    }

    renderProgress() {
      this.progress.replaceChildren();
      for (let i = 0; i < this.items.length; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ls-progress-button';
        btn.setAttribute('aria-label', 'Go to story ' + (i + 1));
        const track = document.createElement('span');
        track.className = 'ls-progress-track';
        const fill = document.createElement('span');
        fill.className = 'ls-progress-fill';
        fill.style.width = (i < this.index ? 100 : 0) + '%';
        track.appendChild(fill);
        btn.appendChild(track);
        btn.addEventListener('click', () => this.show(i));
        this.progress.appendChild(btn);
      }
    }

    updateProgress(percent) {
      const fill = all(this.progress, '.ls-progress-fill')[this.index];
      if (fill) fill.style.width = percent + '%';
    }

    renderMute() {
      one(this.mute, '[data-ls-icon-muted]').hidden = !this.muted;
      one(this.mute, '[data-ls-icon-sound]').hidden = this.muted;
      this.mute.setAttribute('aria-label', this.muted ? 'Unmute video' : 'Mute video');
    }

    renderProduct(item) {
      const hasProduct = !!item.url && !!item.product;
      this.product.hidden = !hasProduct;
      if (!hasProduct) return;
      for (const link of all(this.product, '[data-ls-product-link], [data-ls-product-title]')) link.href = item.url;
      const img = one(this.product, '[data-ls-product-image]');
      const imgLink = one(this.product, '[data-ls-product-link]');
      imgLink.hidden = !item.image;
      if (item.image) { img.src = item.image; img.alt = item.product; }
      one(this.product, '[data-ls-product-title]').textContent = item.product;
      one(this.product, '[data-ls-product-price]').textContent = item.price || '';
      const hasOptions = Number(item.variantCount || 0) > 1;
      const canAdd = item.available === 'true' && !!item.variant;
      this.add.hidden = false;
      this.add.disabled = !canAdd && !hasOptions;
      this.add.textContent = hasOptions ? (this.root.dataset.optionsLabel || 'Choose options') : (canAdd ? (this.root.dataset.addLabel || 'Add to cart') : (this.root.dataset.soldOutLabel || 'Sold out'));
      this.cartLink.hidden = true;
      this.cartLink.textContent = this.root.dataset.cartLinkLabel || 'View cart';
      this.cartLink.href = routeRoot() + 'cart';
    }

    async addToCart() {
      const item = this.items[this.index];
      if (!item || !item.variant || this.add.disabled) return;
      if (Number(item.variantCount || 0) > 1 && item.url) { window.location.assign(item.url); return; }
      const addingIndex = this.index;
      this.add.disabled = true;
      this.add.textContent = 'Adding…';
      try {
        const response = await fetch(routeRoot() + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(item.variant), quantity: 1 }] })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this item');
        if (this.index === addingIndex) {
          this.add.textContent = '✓ Added';
          this.add.hidden = true;
          this.cartLink.hidden = false;
        }
        const detail = { item: payload, source: 'luna-stories' };
        document.dispatchEvent(new CustomEvent('luna:cart-added', { detail, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail, bubbles: true }));
      } catch (error) {
        if (this.index === addingIndex) {
          this.add.disabled = false;
          this.add.textContent = 'Try again';
          this.message.textContent = error.message || 'Could not add to cart';
          this.message.hidden = false;
        }
      }
    }
  }

  const init = (scope = document) => {
    const roots = [];
    if (scope.matches && scope.matches('[data-luna-stories]')) roots.push(scope);
    roots.push(...all(scope, '[data-luna-stories]'));
    for (const root of roots) {
      if (root.dataset.lsReady === '1') continue;
      root.dataset.lsReady = '1';
      new LunaStories(root);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
